var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-form"},[_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"cols":"11"}},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.$l('form_label_Product_classification') || '产品分类'))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }